<template>
  <div>
    <div style="margin: 0 20px 0">
      <div style="height: 40px;width: 100%;" v-if="!isQuick"><!--tabs栏-->
        <div :class="item.index === indexActive ? 'select-active' : 'no-select'" v-for="item in tabs" :key="item.index" @click="selectTab(item)">
          <span>{{item.name}}</span>
        </div>
        <div v-if="indexActive === 1" class="add-open-btn" @click="addOpen()">
          <strong>+</strong>
        </div>
      </div>
      <div v-if="indexActive === 0">
        <el-form style="margin-right: 20px" :model="editHomeForm" :rules="editHomeRules" ref="editHomeForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="家庭/机构" prop="isHome" v-if="moduletag === 3">
            <el-select v-fixZoom disabled style="width: 100%" v-model="editHomeForm.isHome" placeholder="请选择">
              <el-option label="家庭" value="0"></el-option>
              <el-option label="机构" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="telephone">
                <el-input type="number" v-model="editHomeForm.telephone" placeholder="请输入联系电话"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item v-if="editHomeForm.isHome === '0'" label="门牌号" prop="address">
                <el-input placeholder="请输入门牌号" v-model="editHomeForm.address" @blur="testAddress()"></el-input>
              </el-form-item>
              <el-form-item v-if="editHomeForm.isHome === '1'" label="房号" prop="address">
                <el-input placeholder="请输入房号" v-model="editHomeForm.address" @blur="testAddress()"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item v-if="editHomeForm.isHome === '1'" label="所属机构" prop="cid">
            <el-select v-fixZoom :disabled="isQuick" style="width: 100%" v-model="editHomeForm.cid" placeholder="请选择机构" @change="changeCommunity">
              <el-option v-for="item in organizationOptions" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="editHomeForm.isHome === '0'" label="所属小区" prop="cid">
            <el-select v-fixZoom :disabled="isQuick" style="width: 100%" v-model="editHomeForm.cid" placeholder="请选择小区" @change="changeCommunity">
              <el-option v-for="item in communityOptions" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <div style="text-align: right"><el-button size="mini" type="primary" plain @click="setShow()">设置地图坐标</el-button></div>
          <el-row v-if="isSet" style="margin-top: 20px">
            <el-col :span="12">
              <el-form-item label="经度" prop="lng">
                <el-input style="width: 100%" type="number" v-model="editHomeForm.lng" @blur="sendMarkerLngLat()"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="纬度" prop="lat">
                <el-input style="width: 100%" type="number" v-model="editHomeForm.lat" @blur="sendMarkerLngLat()"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="z-index: 9999;margin: 0 10px" v-if="isSet">
          <el-autocomplete v-fixZoom style="width: 100%" class="inline-input" v-model="searchAddress"
                           :fetch-suggestions="querySearch" placeholder="关键词搜索" :trigger-on-focus="false" @select="handleSelect" @blur="changeAddress"></el-autocomplete>
        </div>
        <div style="margin: -45px 10px 0;height: 300px;" v-if="isSet">
          <iframe id="mainIframe" ref="mainIframe" name="mainIframe" style="width: 100%;height: 100%;margin: auto" src="../../../../static/addressMap.html" frameborder="0" scrolling="no"></iframe>
        </div>
        <div v-if="!isQuick" style="margin-top: 20px">
          <el-row style="margin: 0 30px">
            <el-col :span="12">
              <div class="cancel-btn" @click="closeAdd()"><span>取消</span></div>
            </el-col>
            <el-col :span="12">
              <div class="send-btn" @click="submitEditHome('editHomeForm')"><span>确定</span></div>
            </el-col>
          </el-row>
        </div>
        <div v-else>
          <div class="send-btn" @click="submitEditHome('editHomeForm')"><span>确定</span></div>
        </div>
        <div style="height: 20px"></div>
      </div>
      <div v-if="indexActive === 1" style="height: 450px">
        <device-details :deviceObj="deviceObj"></device-details>
      </div>
      <div v-if="indexActive === 2">
        <home-persons :homeObj="homeObj"></home-persons>
      </div>
    </div>
    <!--绑定设备-->
    <el-dialog :visible.sync="addShow" v-if="addShow" width="650px" :show-close="true" :close-on-click-modal="false" center class="all-open" append-to-body>
      <div class="title-top-alarm">
        <div><span>绑定设备</span></div>
        <div class="line-title"></div>
      </div>
      <device-add :addDeviceRow="addRow" v-model="addShow"  @getFatherDevice="getFatherDevice"></device-add>
    </el-dialog>
  </div>
</template>

<script>
import {updateorghome} from '../../../api/relation'
import deviceDetails from '../../../components/datamanagement/quick/components/deviceDetails'
import deviceAdd from './deviceAdd'
import homePersons from './homePersons'
export default {
  name: 'relationEdit',
  components: {deviceDetails, deviceAdd, homePersons},
  model: {
    prop: 'editShow',
    event: 'change'
  },
  props: {
    relationEditRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      tabs: [
        {index: 0, name: '基础信息'},
        {index: 1, name: '设备详情'},
        {index: 2, name: '人员信息'}
      ],
      indexActive: 0,
      isEditPhone: false,
      mapLnglat: {
        lng: '',
        lat: ''
      },
      orgOptions: [],
      orgid: '',
      organizationOptions: [],
      allOptions: [],
      communityOptions: [],
      devicePerson: {
        idDevice: ''
      },
      device: {
        device_id: '',
        installlocation: '',
        phone: ''
      },
      deviceRules: {
        device_id: [{ required: true, message: '请输入设备编号', trigger: 'change' }],
        phone: [{ required: true, message: '请输入设备号码', trigger: 'blur' }]
      },
      editHomeForm: {
        isHome: '',
        id: 0,
        telephone: '',
        address: '',
        orgid: '',
        lng: '',
        lat: '',
        cidobj: '',
        cid: '',
        building: '',
        unit: '',
        room: ''
      },
      editHomeRules: {
        isHome: [{ required: true, message: '请选择添加类型', trigger: 'change' }],
        telephone: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],
        orgid: [{ required: true, message: '请选择所属组织', trigger: 'change' }],
        cid: [{ required: true, message: '请选择所属小区', trigger: 'change' }],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        lng: [{ required: true, message: '请输入', trigger: 'blur' }],
        lat: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      moduletag: '',
      // 绑定设备
      addShow: false,
      addRow: {
        orgTree: [],
        orgcommunitys: [],
        orghomes: [],
        oldpersons: [],
        home: '', // 家信息
        // 家管理编辑添加网关
        isGateway: true,
        row: '', // 设备管理表格信息
        orgids: [],
        isAddPerson: false // 是否添加人绑定设备
      },
      deviceObj: {
        personId: '',
        hid: ''
      },
      homeObj: {},
      isQuick: false,
      // 地图
      searchAddress: '',
      map: '',
      autoComplete: '',
      isSet: false
    }
  },
  created () {
    /* 1、relation.vue 小区管理页面的家庭弹窗 2、homeManagement.vue 家庭/房间管理 页面得到更新按钮 3、quickOpen.vue 快捷操作弹窗 */
    this.golobleObject.sendIsAdd = this.getIsAdd
    this.isQuick = this.relationEditRow.isQuick
    this.moduletag = this.$store.state.user.moduletag
    this.homeObj = this.relationEditRow.row
    this.getEditForm()
  },
  mounted () {
  },
  methods: {
    addOpen () {
      this.addShow = true
    },
    selectTab (item) {
      this.indexActive = item.index
    },
    getEditForm () {
      console.log(this.relationEditRow)
      this.orgOptions = this.relationEditRow.orgTree
      this.communityOptions = []
      this.organizationOptions = []
      let orgcommunity = this.relationEditRow.orgcommunitys
      this.allOptions = this.relationEditRow.orgcommunitys
      for (let i = 0; i < orgcommunity.length; i++) {
        if (orgcommunity[i].zone_type === 1) {
          this.communityOptions.push(orgcommunity[i])
        } else if (orgcommunity[i].zone_type === 2) {
          this.organizationOptions.push(orgcommunity[i])
        }
      }
      this.addRow.home = this.relationEditRow.row
      this.deviceObj.hid = this.relationEditRow.row.id
      this.editHomeForm.id = this.relationEditRow.row.id
      this.editHomeForm.telephone = this.relationEditRow.row.telephone
      this.editHomeForm.address = this.relationEditRow.row.address
      this.editHomeForm.orgid = this.relationEditRow.row.orgid
      this.editHomeForm.lng = this.relationEditRow.row.lng
      this.editHomeForm.lat = this.relationEditRow.row.lat
      this.editHomeForm.cid = this.relationEditRow.row.cid
      this.editHomeForm.building = this.relationEditRow.row.building
      this.editHomeForm.unit = this.relationEditRow.row.unit
      this.editHomeForm.room = this.relationEditRow.row.room
      this.orgid = this.relationEditRow.row.orgid
      for (let i = 0; i < this.allOptions.length; i++) {
        if (this.editHomeForm.cid === this.allOptions[i].id) {
          if (this.allOptions[i].zone_type === 1) {
            this.editHomeForm.isHome = '0'
          } else if (this.allOptions[i].zone_type === 2) {
            this.editHomeForm.isHome = '1'
          }
        }
      }
      this.mapLnglat.lng = this.relationEditRow.row.lng
      this.mapLnglat.lat = this.relationEditRow.row.lat
    },
    testAddress () {
      this.editHomeForm.address = this.editHomeForm.address.replace(/[\r\n]/g, '')
    },
    changeCommunity (id) {
      for (let i = 0; i < this.allOptions.length; i++) {
        if (id === this.allOptions[i].id) {
          let item = this.allOptions[i]
          this.editHomeForm.cid = item.id
          this.editHomeForm.lng = item.lng
          this.editHomeForm.lat = item.lat
          this.editHomeForm.orgid = item.orgid
        }
      }
      this.sendMarkerLngLat()
    },
    submitEditHome (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            id: this.editHomeForm.id,
            telephone: this.editHomeForm.telephone,
            address: this.editHomeForm.address,
            orgid: this.editHomeForm.orgid,
            lng: this.editHomeForm.lng,
            lat: this.editHomeForm.lat,
            cid: this.editHomeForm.cid,
            building: this.editHomeForm.building,
            unit: this.editHomeForm.unit,
            room: this.editHomeForm.room
          }
          updateorghome(data).then(res => {
            this.$notify({title: '成功', message: '成功更新家庭/机构', type: 'success', duration: 2000})
            if (!this.isQuick) {
              this.golobleObject.updateTableHome()
              this.$emit('change', false)
            }
          }).catch(() => {})
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeAdd () {
      this.$emit('change', false)
    },
    getFatherDevice () {},
    setShow () {
      console.log(999)
      this.isSet = !this.isSet
    },
    sendMarkerLngLat () {
      if (this.editHomeForm.lng !== 0 && this.editHomeForm.lng !== '' && this.editHomeForm.lat !== 0 && this.editHomeForm.lat !== '') {
        let item = { lng: this.editHomeForm.lng, lat: this.editHomeForm.lat }
        window.frames['mainIframe'].window.getParentAddress(item)
      }
    },
    querySearch (queryString, cb) {
      this.autoComplete.search(queryString, function (status, result) {
        let re = []
        for (let i = 0; i < result.tips.length; i++) {
          let obj = {
            lng: result.tips[i].location.lng,
            lat: result.tips[i].location.lat,
            value: result.tips[i].district + result.tips[i].name
          }
          re.push(obj)
        }
        cb(re)
      })
    },
    handleSelect (item) {
      console.log(item)
      this.editHomeForm.lng = item.lng
      this.editHomeForm.lat = item.lat
      if (this.editHomeForm.address === '') {
        this.editHomeForm.address = item.value
      }
      this.selectMarker(item)
    },
    changeAddress () {
      if (this.editHomeForm.address === '') {
        this.editHomeForm.lng = ''
        this.editHomeForm.lat = ''
      }
    },
    selectMarker (item) {
      window.frames['mainIframe'].window.getParentAddress(item)
    },
    getIsAdd (obj) {
      if (obj.type === 'autoComplete') {
        this.autoComplete = obj.autoComplete
        if (this.editHomeForm.lng !== 0 && this.editHomeForm.lng !== '' && this.editHomeForm.lat !== 0 && this.editHomeForm.lat !== '') {
          let item = {
            lng: parseFloat(this.editHomeForm.lng),
            lat: parseFloat(this.editHomeForm.lat)
          }
          window.frames['mainIframe'].window.getParentAddress(item)
        }
      } else if (obj.type === 'lnglat') {
        this.editHomeForm.lng = obj.lng
        this.editHomeForm.lat = obj.lat
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/relationEdit.vue